"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    body1StrongClassNames: function() {
        return body1StrongClassNames;
    },
    useBody1StrongStyles: function() {
        return useBody1StrongStyles;
    }
});
const _react = require("@griffel/react");
const body1StrongClassNames = {
    root: 'fui-Body1Strong'
};
const useBody1StrongStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
